export default __webpack_public_path__ + "static/media/road-H-photo.862c6993.svg";